/*
 * Created by TUTEHUB.
 * Copyright © TUTEHUB. All rights reserved.
 * ------------------------
 * Non-disclosure Terms
 * ------------------------
 * These codes are TUTEHUB's property, as the developer, such as employee, contractor, and intern, working for TUTEHUB cannot disclose, spread, copy, preserve, sell, and do other activities without the consent of TUTEHUB.
 * Technique Support: jobyme88.com
 */

import React from 'react'
import { withTranslation } from 'react-i18next'

function CardUnit(props) {
    return (
        <div className="card-unit">
            <div className="title">{props.title}</div>
            <div className="des">{props.des}</div>
        </div>
    )
}

export default withTranslation()(CardUnit)